import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleTenancyChange({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#666" opacity={0.92} cx={28} cy={28} r={28} />
        <g fill="#FFF" fillRule="nonzero">
          <path d="M32.3 16.8a1 1 0 011.31-.09l.1.08 4.5 4.5a1 1 0 01.08 1.32l-.08.1-4.5 4.5a1 1 0 01-1.5-1.32l.08-.1L36.1 22l-3.8-3.8a1 1 0 01-.08-1.31l.08-.1z" />
          <path d="M36 21a1 1 0 01.12 2H18a1 1 0 01-.12-2H36zm-14.7 8.3a1 1 0 011.49 1.31l-.08.1-3.8 3.79 3.8 3.8a1 1 0 01.08 1.31l-.08.1a1 1 0 01-1.32.08l-.1-.08-4.5-4.5a1 1 0 01-.08-1.32l.08-.1 4.5-4.5z" />
          <path d="M37.5 33.5a1 1 0 01.12 2H19a1 1 0 01-.12-2H37.5z" />
        </g>
      </g>
    </svg>
  );
}

SvgPicCircleTenancyChange.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleTenancyChange.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleTenancyChange svgRef={ref} {...props} />
));
export default ForwardRef;
